import { render } from "./OptionalWrapper.vue?vue&type=template&id=34a3eda2"
import script from "./OptionalWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionalWrapper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helper/OptionalWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34a3eda2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34a3eda2', __exports__)) {
    api.reload('34a3eda2', __exports__)
  }
  
  module.hot.accept("./OptionalWrapper.vue?vue&type=template&id=34a3eda2", () => {
    api.rerender('34a3eda2', render)
  })

}


export default __exports__